import React, { useEffect, useState } from "react";
import {Box, Table, TableBody, TableCell,Chip, TableContainer, TableHead, TableRow, Paper, Checkbox, IconButton, 
    Tooltip, Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography, TablePagination, TextField,FormControlLabel,
    Autocomplete,} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from '@mui/icons-material/Edit';
import axios from "axios";
import CancelSharpIcon from '@mui/icons-material/CancelSharp';
import CheckCircleSharpIcon from '@mui/icons-material/CheckCircleSharp';
import { useNavigate } from "react-router-dom";
import '../PendingEvents/PendingEvents.css'

const GuidePendingRequest = () => {
  const [pendingEvents, setPendingEvents] = useState([]);
  const [selected, setSelected] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [value, setValue] = useState(0);
  const [pendingImageFile, setPendingImageFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reason,setReason] = useState("");
  useEffect(() => {
    const fetchPendingEvents = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/pendingGuides`);
        setPendingEvents(response.data);
      } catch (error) {
        console.error("Error fetching pending events:", error);
      }
    };
    fetchPendingEvents();
  }, []);

  async function getUsernamefromCookie() {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, { withCredentials: true }); 
      if (response.data.username ) {
        setUsername(response.data.username);
        setIsLoggedIn(true);
        setUserType(response.data.user);
      } else {
        setIsLoggedIn(false);
        navigate('/login'); 
      }
    } catch (error) {
      console.error('Error fetching login status:', error);
      navigate('/login'); 
    }
  }

  useEffect(() => {
    getUsernamefromCookie();
  }, []);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userType, setUserType] = useState('');
  const [userName, setUsername] = useState('');
  const [formData, setFormData] = useState({
      name: '',
      eventImage: '',
      lastEditedBy: '',
      postStatus: '',
    });

  const navigate = useNavigate();

  const handleSelectAllClick = (event) => {
    setSelected(event.target.checked ? pendingEvents.map((event) => event._id) : []);
  };

  const handleRowClick = (id) => {
    setSelected((prevSelected) =>
      prevSelected.includes(id) ? prevSelected.filter((item) => item !== id) : [...prevSelected, id]
    );
  };

 const handleApprove = async (id) => {
  try {
    await axios.put(`${API_BASE_URL}/api/approveGuide/${id}`, {
      approvedBy:userName
    }, {
      headers: {
        "Content-Type": "application/json"
      }
    });

    setPendingEvents((prev) => prev.filter((event) => event._id !== id));
  } catch (error) {
    console.error("Error approving event:", error);
  }
};

const handleReject = async (id) => {
  try {
    await axios.put(`${API_BASE_URL}/api/rejectGuide/${id}`, {
      approvedBy: userName
    }, {
      headers: {
        "Content-Type": "application/json"
      }
    });

    setPendingEvents((prev) => prev.filter((event) => event._id !== id));
  } catch (error) {
    console.error("Error rejecting event:", error);
  }
};

const [openDialogreason, setOpenDialogreason] = useState(false);
const [currentEventId, setCurrentEventId] = useState(null);

const handleOpenDialogReason = (id) => {
  setCurrentEventId(id);
  setOpenDialogreason(true);
};

const handleCloseDialogReason = () => {
  setOpenDialogreason(false);
  setReason("");
};

const handleInactive = async () => {
  try {
    await axios.put(`${API_BASE_URL}/api/inactiveGuide/${currentEventId}`, {
      approvedBy: userName,
      rejectionReason: reason
    });

    setPendingEvents((prev) => prev.filter((event) => event._id !== currentEventId));
    handleCloseDialogReason();
  } catch (error) {
    console.error("Error inactiveGuide event:", error);
  }
};

const handleOpenDialog = (event) => {
  setSelectedEvent(event);
  setFormData(event); 
  setOpenDialog(true);
};


  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedEvent(null);
    setPendingImageFile(null);
    setPendingDocs([]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedEvent((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiSelectChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: [...value],
    }));
  };

  const handleFormChange = (e) => {
  const { name, value, type, checked } = e.target;
  setFormData((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const response = await axios.put(
      `${API_BASE_URL}/api/approveGuide/${selectedEvent._id}`,
      formData,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
    handleCloseDialog();
  } catch (error) {
    console.error('Error submitting event:', error);
  }
};

  const [pendingDocs, setPendingDocs] = useState([]);

//   const handleSave = async () => {
//     try {
      
//       const response = await axios.get(`${API_BASE_URL}/api/pendingGuides`);
//       setPendingEvents(response.data);
    
//     } catch (err) {
//       console.error("Submission failed:", err);
//     }
//   };
 
  return (
    <Box sx={{ width: '100%', padding: 0, margin: 0 }}>
  {isLoggedIn && userName.length > 0 ? (
    <>
     <div className="form-container-1">
     <Box sx={{ display: "flex",  gap: 2, flexWrap: "wrap", justifyContent: "center", alignItems: "center",}}></Box>
      </div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {/* <TableCell padding="checkbox">
                <Checkbox
                  indeterminate={selected.length > 0 && selected.length < pendingEvents.length}
                  checked={selected.length === pendingEvents.length}
                  onChange={handleSelectAllClick}
                />
              </TableCell> */}
              <TableCell> Guide</TableCell>
              <TableCell> Pdf</TableCell>
              <TableCell align="center" colSpan={4}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pendingEvents
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((event) => (
                <TableRow key={event._id} hover>
                  {/* <TableCell padding="checkbox">
                    <Checkbox
                      checked={selected.includes(event._id)}
                      onClick={() => handleRowClick(event._id)}
                    />
                  </TableCell> */}
                  <TableCell>
              <Box  className="event-card-postApproval">
                {/* <img src={event.eventImage} alt="Event" className="category-image"  onClick={() => navigate(`/event/${event._id}`)}/> */}

      <Box className="event-details">
        <Typography   onClick={() => handleOpenDialog(event)}>
          {event.name}
        </Typography>
      </Box>
      </Box>
      </TableCell>
      <TableCell>
        {event.eventImage ? (
          <a href={event.eventImage} target="_blank" rel="noopener noreferrer" className="no-border">{event.name}</a>
        ) : (
          <span>No file</span>
        )}
      </TableCell>

                  <TableCell>
                    <Tooltip title="Approve">
                      <IconButton color="success" onClick={() => handleApprove(event._id)}>
                        <CheckCircleIcon />
                      </IconButton>
                    </Tooltip>
                    </TableCell>
                    <TableCell>
                    <Tooltip title="Reject">
                      <IconButton color="error" onClick={() => handleReject(event._id)}>
                        <CancelIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                   <TableCell>
                 <Tooltip title="Inactive">
                <Button color="error" onClick={() => handleOpenDialogReason(event._id)}>
                 Inactive
                </Button>
              </Tooltip>

                    </TableCell>
                  <TableCell>
                    <Tooltip title="Edit Guide">
                      <IconButton onClick={() => handleOpenDialog(event)}>
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={pendingEvents.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) =>
          setRowsPerPage(parseInt(event.target.value, 10))
        }
      />
       {/* {selectedEvent &&( */}
        <Dialog open={openDialogreason} onClose={handleCloseDialogReason}>
        <DialogTitle>Enter Rejection Reason</DialogTitle>
        <DialogContent>
           <Box sx={{  width:'100%', minHeight:170 }}>
            <h1></h1>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Rejection Reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogReason}>Cancel</Button>
          <Button color="error" onClick={handleInactive}>Review Again</Button>
        </DialogActions>
      </Dialog>
        {/* )} */}
      {selectedEvent && (
        <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle>Edit Guide</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Typography variant="subtitle1" className="meta-label"></Typography>
            <TextField
              fullWidth
              name="eventName"
              label="Guide Name"
              value={formData.name}
              onChange={handleFormChange}
            />
              {/* {pendingDocs.length > 0 ? (
                pendingDocs.map((file, index) => (
                  <Box key={index}>
                    <Typography>{file.name}</Typography>
                  </Box>
                ))
              ) : (
                Array.isArray(formData.attachments) &&
                formData.attachments.map((url, index) => (
                  <Box key={index}>
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {formData.eventName} PDF {index + 1}
                    </a>
                  </Box>
                ))
              )} */}
        {pendingEvents.map((g) => ( g.eventImage ? 
            ( <a key={g._id} href={g.eventImage} target="_blank" 
            rel="noopener noreferrer" >{g.name}</a> )
             : ( <span key={g._id}>No file</span>)))}

              <Button variant="outlined" component="label">
                Replace PDFs
                <input
                  type="file"
                  hidden
                  multiple
                  accept="application/pdf"
                  onChange={(e) => setPendingDocs(Array.from(e.target.files))}
                />
              </Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary">
            Cancel
          </Button>
          {/* <Button onClick={handleSave} color="primary">
             Save 
          </Button> */}
          <Button onClick={handleSubmit} color="primary">
             Approve
          </Button>
        </DialogActions>
      </Dialog>
      

      )}

      {selected.length > 0 && (
        <Box
          sx={{
            padding: 2,
            display: 'flex',
            gap: 2,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => selected.forEach(handleApprove)}
          >
            Approve Selected
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => selected.forEach(handleReject)}
          >
            Reject Selected
          </Button>
        </Box>
      )}
    </>
  ) : (
    <Typography variant="h6" textAlign="center">
      
    </Typography>
  )}
</Box>

  );
};

export default GuidePendingRequest;
